


























































































































import Vue from 'vue';

export default Vue.extend({
  auth: true,
  data: () => ({
    coopLegalProtectionError: undefined as any,
    hasLegalProtection: false,
    isLoading: false,
  }),
  computed: {
    tenant() {
      return this.$route.params.tenant;
    },
    workspace() {
      return this.$route.params.workspace;
    },
    coopLegalProtectionText() {
      return this.hasLegalProtection ? this.$t('page.memberData.title.cancelCoopLegalProtection') : this.$t('page.memberData.title.applyCoopLegalProtection');
    },
    coopLegalProtectionTitle() {
      return this.hasLegalProtection ? this.$t('page.memberData.title.multiLegalProtectionEnd') : this.$t('page.memberData.title.multiLegalProtectionCreate');
    },
  },
  async mounted() {
    await this.loadCoopLegalProtection();
  },
  methods: {
    async loadCoopLegalProtection() {
      this.isLoading = true;
      try {
        const response = await this.$service.api.memberships.getMyMembership();
        this.hasLegalProtection = response?.membership?.hasMultiLegalProtection ?? false;
      } catch (e) {
        this.coopLegalProtectionError = e;
        console.error(e);
      }
      this.isLoading = false;
    },
  },
});
